import momentTZ from 'moment-timezone';
momentTZ.tz.setDefault('Europe/London');

export default momentTZ;
